import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppState, Auth0Provider } from '@auth0/auth0-react';

type Props = {
	children: ReactNode;
};

export const AuthWrapper: React.FC<Props> = ({ children }) => {
	const navigate = useNavigate();

	const onRedirectCallback = (appState?: AppState | undefined) => {
		navigate(
			appState && appState.returnTo
				? appState.returnTo
				: window.location.pathname
		);
	};

	return (
		<Auth0Provider
			domain={String(process.env.REACT_APP_AUTH0_DOMAIN)}
			clientId={String(process.env.REACT_APP_AUTH0_CLIENT_ID)}
			onRedirectCallback={onRedirectCallback}
			authorizationParams={{
				redirect_uri: window.location.origin,
				audience: process.env.REACT_APP_AUTH0_AUDIENCE,
				scope: process.env.REACT_APP_AUTH0_SCOPE,
			}}
		>
			{children}
		</Auth0Provider>
	);
};
